<script setup />

<template>
  <div class="text-mild text-size-14 text">
    退勤処理が完了後、『マイページの「給与」』に入金されます。引出方法は以下2パターンです。<br />
    ①早期引出：24時間365日好きなタイミングで報酬の引出が可能(手数料無料)<br />
    ②定期振込：当月締めの翌月15日払い(該当日が休祝日の場合は前営業日)
  </div>
</template>

<style lang="scss" scoped>
.text {
  display: contents;
}
</style>
